import { Button, IconEdit16 } from '@cian/ui-kit';
import * as React from 'react';

export interface INoteButtonProps {
  onClick(): void;
  entityId: number;
}

export class NoteButton extends React.PureComponent<INoteButtonProps> {
  public render() {
    const { onClick } = this.props;

    return (
      <div>
        <Button
          size="XS"
          theme="fill_secondary"
          onClick={onClick}
          title="Оставить заметку к объявлению (видно только вам)"
          beforeIcon={<IconEdit16 color="primary_100" />}
          data-testid="NoteButton"
        />
      </div>
    );
  }
}
